import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import Spinner from "../../components/Reuseable/Spinner";

type Props = {};
const PosScreenComponent = loadable(() => import("../../components/PosScreen"));
const PosScreen = (props: Props) => {
  const { pageSize, offset, setPageSize, setOffset } = usePaginationState();
  const [categoryId, setCategoryId] = useState("");
  const { data: categoryData, isPending: categoryDataLoading } = useGetHook({
    queryKey: ["pos-screen-category", pageSize, offset],
    url: `${APIS.SCREEN_CATEGORY}`,
    params: {
      limit: pageSize,
      offset: offset,
    },
  });
  const { data: customerData, isPending: productLoading } = useGetHook({
    queryKey: ["customer"],
    url: `${APIS.CUSTOMER}`,
    params: {},
  });
  const { data: category, isPending: categoryLoading } = useGetHook({
    queryKey: ["category"],
    url: `${APIS.CATEGORY}`,
    params: {},
  });
  const { data: product, isPending: productListLoading } = useGetHook({
    queryKey: ["product"],
    url: `${APIS.PRODUCT}`,
    params: {},
  });

  return (
    <PosScreenComponent
      categoryData={categoryData}
      customerData={customerData}
      setPageSize={setPageSize}
      setOffset={setOffset}
      setCategoryId={setCategoryId}
      pageSize={ pageSize}
      offset={offset}
      categoryId={categoryId}
      category={category}
      product={product}
      categoryDataLoading={categoryDataLoading}
    />
  );
};

export default PosScreen;
